(function() {
	'use strict';

	angular.module('cycle').config(config);

	function config($stateProvider) {
		$stateProvider.state('cycle', {
			url : '/cycle',
			views : {
				'cycleView' : {
					templateUrl : 'cycle/views/cycle.tpl.html',
					controller : 'CycleCtrl',
					controllerAs : 'cycle'
				}
			}
		});
	}
}());
